export default __webpack_public_path__ + "static/media/TOASTER MESSAGES-1731423732590.c97e5283.png";